<ng-container *ngIf="view === 'initial'">

  <div class="row mt-9">

    <div [class]="determineSize()">

      <label class="form-label fw-bolder text-dark fs-6">Search for an address in...</label>

      <div>
        <nz-radio-group [(ngModel)]="postcodeType">
          <label nz-radio nzValue="UK">UK</label>
          <label nz-radio nzValue="Jersey">Jersey</label>
        </nz-radio-group>
      </div>

      <ng-container *ngIf="postcodeType === 'Jersey'">

        <label class="form-label fw-bolder text-dark fs-6 mt-4">Enter a jersey address to search for an address</label>
        <p class="mt-1 mb-2">Hint: You can search postcode and house number at same time</p>
        <form [formGroup]="addressLookup"  (submit)="doPostcodeLookupJersey()">
          <div class="d-flex postcode-search">

        <input
          class="form-control"
          type="tel"
          placeholder="Search address..."
          formControlName="address"
          autocomplete="chrome-off"
        />

        <button [disabled]="!addressLookup.valid" type="submit" class="btn btn-sm btn-theme w-225px d-inline-flex align-items-center">
            <span
              data-inline="'./assets/media/icons/duotune/general/gen021.svg'"
              class="svg-icon svg-icon-3"
            ></span>
          <ng-container *ngIf="($searching | async) === false">
            <span class="indicator-label">Find Address</span>
          </ng-container>
          <ng-container *ngIf="$searching | async">
                <span class="indicator-progress" [style.display]="'block'">
                  Searching...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
          </ng-container>
        </button>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="postcodeType === 'UK'">

      <label class="form-label fw-bolder text-dark fs-6 mt-4">Enter a UK postcode to search for an address</label>
      <form (submit)="doPostcodeLookup()" [formGroup]="postcodeLookup">
      <div class="d-flex postcode-search">

          <input
            class="form-control"
            type="tel"
            placeholder="Lookup Postcode"
            formControlName="postcode"
            autocomplete="chrome-off"
          />

          <button [disabled]="!postcodeLookup.valid" type="submit" class="btn btn-sm btn-theme w-225px d-inline-flex align-items-center">
            <span
              data-inline="'./assets/media/icons/duotune/general/gen021.svg'"
              class="svg-icon svg-icon-3"
            ></span>
              <ng-container *ngIf="($searching | async) === false">
                <span class="indicator-label">Find Address</span>
              </ng-container>
              <ng-container *ngIf="$searching | async">
                <span class="indicator-progress" [style.display]="'block'">
                  Searching...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
            </ng-container>
          </button>

      </div>
      </form>

      </ng-container>

      <p class="mt-4">Only UK & Jersey postcodes are supported</p>

      <p>Can't find your postcode? <a class="fw-boldest text-primary" (click)="enterManual()">Enter manually instead</a></p>

    </div>

  </div>

</ng-container>

<ng-container *ngIf="view === 'select'">

  <div class="d-flex align-items-center my-7">

    <h3 class="m-0">Select An Address</h3>

    <button class="btn btn-theme btn-sm ms-auto" (click)="enterManual()">Enter Manually</button>

  </div>

  <div class="address-list">

    <div class="single-address" *ngFor="let item of postCodeResults | async" (click)="selectAddress(item)">

        <ng-container *ngIf="(postCodeCountry | async) === 'UK'">
          {{address.formatAddressOneLine(item.formatted_address)}}
        </ng-container>
        <ng-container *ngIf="(postCodeCountry | async) === 'Jersey'">
          {{item.lineFormat}}
        </ng-container>

    </div>

  </div>


</ng-container>

<ng-container *ngIf="view === 'manual'" [formGroup]="form">


  <div class="row">

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Building Name</label>
        <input
          class="form-control"
          type="tel"
          placeholder="Building Name"
          name="building_name"
          formControlName="building_name"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">House / Flat Number</label>
        <input
          class="form-control"
          type="text"
          placeholder="House / Flat Number"
          name="house_number"
          formControlName="house_number"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Street</label>
        <input
          class="form-control"
          type="text"
          placeholder="Street"
          name="address_line_1"
          formControlName="address_line_1"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Address Line 2</label>
        <input
          class="form-control"
          type="text"
          placeholder="Address Line 2"
          name="address_line_2"
          formControlName="address_line_2"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Town / Parish</label>
        <input
          class="form-control"
          type="text"
          placeholder="Town"
          name="town"
          formControlName="town"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">City</label>
        <input
          class="form-control"
          type="text"
          placeholder="City"
          name="city"
          formControlName="city"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">County</label>
        <input
          class="form-control"
          type="text"
          placeholder="County"
          name="county"
          formControlName="county"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Post Code</label>
        <input
          class="form-control"
          type="text"
          placeholder="Post Code"
          name="postcode"
          formControlName="postcode"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>

    <div class="col-6">

      <!--begin::Form group-->
      <div class="fv-row mb-7">
        <label class="form-label fw-bolder text-dark fs-6">Country</label>
        <input
          class="form-control"
          type="text"
          placeholder="Country"
          name="country"
          formControlName="country"
          autocomplete="chrome-off"
        />
      </div>
      <!--end::Form group-->

    </div>


  </div>

</ng-container>

